import { useAppMode } from '@/contexts/AppModeContext';
import { LinkedAccountsPanel, SampleAccount } from '../LinkedAccountsPanel';
import { ClientManager, CompliancePanel } from '../advisor';
import { ClientInfo } from '@/types/portfolio';

interface DashboardSidebarProps {
  excludeLinkedAccounts?: boolean;
  sampleAccounts: SampleAccount[];
  clientInfo?: ClientInfo;
  onClientSelect?: (client: { name: string; riskTolerance: ClientInfo['riskTolerance'] }) => void;
  onClose?: () => void;
}

export function DashboardSidebar({ 
  excludeLinkedAccounts = false, 
  sampleAccounts,
  clientInfo,
  onClientSelect,
  onClose
}: DashboardSidebarProps) {
  const { isConsumer, isAdvisor } = useAppMode();

  return (
    <div className="space-y-4 sm:space-y-6">
      {isConsumer && (
        <>
          {!excludeLinkedAccounts && (
            <LinkedAccountsPanel 
              onHoldingsSync={() => {}} 
              sampleAccounts={sampleAccounts} 
            />
          )}
        </>
      )}

      {isAdvisor && (
        <>
          <ClientManager 
            onSelectClient={(client) => {
              onClientSelect?.(client);
              onClose?.();
            }}
          />
          {clientInfo && <CompliancePanel clientName={clientInfo.name} />}
        </>
      )}
    </div>
  );
}
